import { useTranslation } from 'next-i18next'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'

import { LeaderboardData } from '~/Leaderboard/types/leaderboard.types'
import ArrowDownBoldIcon from '~/components/Icons/svgs/ArrowDownBoldIcon'

export default function PromotionLine({
  index,
  leaderboardData,
}: {
  index: number
  leaderboardData: LeaderboardData
}): React.ReactElement {
  const { t } = useTranslation('leaderboard')
  const isPromotion = index === leaderboardData?.promotionSettings?.promote && index !== 0
  const isAnyoneStying =
    leaderboardData?.leaderboardCapacity -
    leaderboardData?.promotionSettings?.demote -
    leaderboardData?.promotionSettings?.promote

  if (isPromotion) {
    return (
      <div
        className={`${
          isAnyoneStying ? 'mb-6' : ''
        } flex justify-center items-center border-b border-white py-6 gap-2 text-lg font-semibold text-green`}
      >
        <span className="rotate-180">
          <SVGIcon icon={ArrowDownBoldIcon} pathClassName="text-green" />
        </span>
        {t('leaguePromotion')}
        <span className="rotate-180">
          <SVGIcon icon={ArrowDownBoldIcon} pathClassName="text-green" />
        </span>
      </div>
    )
  }

  return <></>
}
